/* Comprobador «¿Cumple tu tienda la normativa de la UE?» de lineagrafica.es (repo LINEA-GRAFICA/lg-web-tools, carpeta
   tema-ue/). Pinta la sección lg-tool-ue contra https://tools.lineagrafica.es/api/normativa: formulario, etapas mientras
   analiza, nota con anillo, fechas clave, lo que ve un visitante nuevo (banner de cookies), grupos con el arreglo según la
   plataforma (y nuestra app o módulo si lo hay) y un único bloque con el formulario del lead. */
(function () {
  var root = document.querySelector('[data-lgue]');
  if (!root) return;
  var API = root.getAttribute('data-api');
  var LOC = root.getAttribute('data-lang') || 'es';
  var LANG = LOC.split('-')[0].toLowerCase();
  var ALL = window.LGUE_I18N || {};
  var T = ALL[LOC] || ALL[LANG] || ALL.es || {};
  var BASE = ALL.es || {};
  var PRIVACY = root.getAttribute('data-privacy') || '/policies/privacy-policy';
  var IA_URL = root.getAttribute('data-ia') || '';
  var app = root.querySelector('[data-lgue-app]');
  var out = root.querySelector('[data-lgue-out]');
  var REDUCED = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var STAGES = ['home', 'legal', 'product', 'browser', 'ai'];
  var GRUPOS = ['info', 'contract', 'privacy', 'a11y', 'tax'];
  var ORDEN = { fail: 0, warn: 1, probable: 2, na: 3, ok: 4, info: 5 };
  // Nuestras apps (Shopify) y módulos (PrestaShop) que lo arreglan: data-p-<clave> con la URL (vacía = no sale).
  var PROD = function (k) { return root.getAttribute('data-p-' + k) || ''; };
  var ARREGLA = {
    shopify: { withdrawal_button: 'shop-withdrawal', withdrawal_info: 'shop-withdrawal', guarantee_notice: 'shop-guarantee', guarantee_terms: 'shop-guarantee', vat_b2b: 'shop-vies', oss: 'shop-oss' },
    prestashop: { gpsr: 'ps-gpsr', withdrawal_button: 'ps-withdrawal', withdrawal_info: 'ps-withdrawal', guarantee_notice: 'ps-guarantee', guarantee_terms: 'ps-guarantee', cookie_banner: 'ps-cookies',
      a11y_basics: 'ps-a11y', a11y_statement: 'ps-a11y', omnibus: 'ps-omnibus', vat_b2b: 'ps-vat', oss: 'ps-vat' }
  };
  // Idiomas con ficha traducida en la App Store (el resto la ve en inglés).
  var TIENDA_LOC = { es: 'es', de: 'de', fr: 'fr', it: 'it', pl: 'pl', pt: 'pt-PT', 'pt-PT': 'pt-PT' };
  var GUIA = { withdrawal_button: 'guide-withdrawal', withdrawal_info: 'guide-withdrawal', guarantee_notice: 'guide-guarantee', guarantee_terms: 'guide-guarantee', green: 'guide-green' };
  // Ítems informativos o grises que llevan explicación.
  var INFO_TXT = { omnibus: 1, disputes: 1, cookie_banner: 1, a11y_scope: 1, vat_b2b: 1, oss: 1, gpsr: 1, guarantee_notice: 1, prices_vat: 1, a11y_basics: 1 };
  var sondeo = null;
  out.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-lgue-app]');
    if (a) ga('ue_check_app', { app: a.getAttribute('data-lgue-app'), lang: LOC });
  });

  function t(ruta, vars) {
    var get = function (o) { return ruta.split('.').reduce(function (a, k) { return a && a[k] != null ? a[k] : undefined; }, o); };
    var s = get(T);
    if (s == null) s = get(BASE);
    if (s == null) s = '';
    return String(s).replace(/\{(\w+)\}/g, function (m, k) { return vars && vars[k] != null ? vars[k] : m; });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function dec(s) { var d = document.createElement('textarea'); d.innerHTML = String(s || ''); return d.value; }
  function ga(ev, p) {
    try { if (window.gtag) window.gtag('event', ev, p); else (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: ev }, p)); } catch (e) {}
  }
  function api(ruta, opts) {
    return fetch(API + ruta, Object.assign({ credentials: 'omit' }, opts || {})).then(function (r) {
      if (r.status === 429) return { ok: false, error: 'rate' };
      return r.json().catch(function () { return { ok: false, error: 'generic' }; });
    }, function () { return { ok: false, error: 'generic' }; });
  }
  function ico(st) { return { ok: '✓', probable: '✓', warn: '!', fail: '✕', na: '?', info: 'i' }[st] || '·'; }
  function nivel(n) { return n == null ? 'na' : n >= 80 ? 'high' : n >= 50 ? 'mid' : 'low'; }

  /* ---------- Formulario ---------- */
  app.innerHTML = '<form class="lgue__form" novalidate><label class="lgue__sr" for="lgue-url">' + esc(t('label')) + '</label>' +
    '<input id="lgue-url" type="text" inputmode="url" autocomplete="url" spellcheck="false" maxlength="200" placeholder="' + esc(t('placeholder')) + '">' +
    '<button class="lgue__btn" type="submit">' + esc(t('button')) + '</button></form><p class="lgue__note">' + esc(t('note')) + '</p>';
  var form = app.querySelector('form'), input = app.querySelector('input'), btn = app.querySelector('button');
  var q = new URLSearchParams(location.search).get('url');
  if (q) input.value = q.slice(0, 200);
  // Versión interna (página no enlazada, data-interno): pide la URL (dominio, enlace de vista previa compartido o la de
  // proyectos-lineagrafica.com) y, solo si la tienda lo pide, la contraseña de Shopify o el usuario y la contraseña de basic
  // auth: lo detecta /api/interno/acceso. Lo de la tienda solo viaja en el cuerpo del POST a /api/normativa/interno y no se
  // guarda en ningún sitio. Sin token: basta con que la página no se indexe (Jose, 19/10/2026).
  var INTERNO = root.hasAttribute('data-interno') ? interno() : null;
  function interno() {
    var campo = function (id, txt, tipo) { return '<label class="lgue__in-f"><span>' + txt + '</span><input id="lgue-' + id + '" type="' + tipo + '" autocomplete="' + (tipo === 'password' ? 'new-password' : 'off') + '" spellcheck="false" maxlength="200"></label>'; };
    var box = document.createElement('div');
    box.className = 'lgue__interno';
    box.innerHTML = '<p class="lgue__in-info" hidden></p>' +
      '<div data-k="password" hidden>' + campo('password', 'Contraseña de la tienda', 'password') + '</div>' +
      '<div data-k="basic" hidden>' + campo('user', 'Usuario', 'text') + campo('pass', 'Contraseña', 'password') + '</div>';
    form.insertAdjacentElement('afterend', box);
    input.maxLength = 500;
    var parte = function (k) { return box.querySelector('[data-k="' + k + '"]'); };
    var v = function (id) { return box.querySelector('#lgue-' + id).value; };
    var info = box.querySelector('.lgue__in-info');
    function pide(k) { parte('password').hidden = k !== 'password'; parte('basic').hidden = k !== 'basic'; }
    function aviso(txt) { info.textContent = txt || ''; info.hidden = !txt; }
    var espera, ultima = '';
    function sondear() {
      var url = input.value.trim();
      if (!url || url === ultima) return;
      ultima = url;
      api('/api/interno/acceso', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ url: url }) }).then(function (r) {
        if (input.value.trim() !== url) return;
        if (!r.ok) return aviso(r.error === 'preview' ? ERR_INTERNO.preview : '');
        pide(r.needs);
        aviso([r.host, r.preview ? 'vista previa' : '', r.needs === 'password' ? 'con contraseña' : r.needs === 'basic' ? 'con usuario y contraseña' : ''].filter(Boolean).join(' · '));
      });
    }
    input.addEventListener('input', function () { clearTimeout(espera); espera = setTimeout(sondear, 700); });
    input.addEventListener('blur', sondear);
    if (input.value) sondear();
    return {
      pide: pide,
      datos: function () {
        var d = {};
        if (!parte('password').hidden) d.password = v('password');
        if (!parte('basic').hidden) { d.user = v('user').trim(); d.pass = v('pass'); }
        return d;
      }
    };
  }
  var ERR_INTERNO = { password: 'La tienda tiene contraseña: escríbela y vuelve a comprobar.', auth: 'La tienda pide usuario y contraseña (o los que has puesto no valen).',
    preview: 'Ese enlace de vista previa no lleva a ninguna tienda (puede haber caducado).', credentials: 'Revisa el usuario y la contraseña (el usuario no puede llevar «:»).' };

  form.addEventListener('submit', function (ev) {
    ev.preventDefault();
    var v = input.value.trim();
    if (!v) { input.focus(); return; }
    lanzar(v);
  });

  function lanzar(url) {
    btn.disabled = true;
    cargando('home');
    out.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'start' });
    (INTERNO ? api('/api/normativa/interno', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(Object.assign({ url: url, lang: LANG }, INTERNO.datos())) })
      : api('/api/normativa?url=' + encodeURIComponent(url) + '&lang=' + LANG)).then(function (r) {
      if (!r.ok || !r.id) { btn.disabled = false; return error(r.error); }
      ga('ue_check_run', { cached: !!r.cached });
      seguir(r.id);
    });
  }
  function seguir(id) {
    var inicio = Date.now();
    clearTimeout(sondeo);
    (function paso() {
      api('/api/normativa/r/' + encodeURIComponent(id) + '?lang=' + LANG).then(function (r) {
        if (r && r.state === 'running') {
          cargando(r.stage, r.host);
          if (Date.now() - inicio > 150000) { btn.disabled = false; return error('timeout'); }
          sondeo = setTimeout(paso, 1400);
          return;
        }
        btn.disabled = false;
        if (!r || !r.ok) return error(r && r.error);
        try { history.replaceState(null, '', '#r=' + id); } catch (e) {}
        pintar(r);
      });
    })();
  }

  /* ---------- Etapas ---------- */
  function cargando(stage, host) {
    var i = Math.max(0, STAGES.indexOf(stage));
    var box = out.querySelector('.lgue__stages');
    if (!box) {
      out.innerHTML = '<div class="lgue__card lgue__stages"><div class="lgue__scan" aria-hidden="true"><span></span></div><p class="lgue__stages-host"></p><ol>' +
        STAGES.map(function (s) { return '<li data-s="' + s + '"><span class="lgue__dot"></span>' + esc(t('stages.' + s)) + '</li>'; }).join('') + '</ol></div>';
      box = out.querySelector('.lgue__stages');
    }
    if (host) box.querySelector('.lgue__stages-host').textContent = host;
    [].forEach.call(box.querySelectorAll('li'), function (li, k) { li.className = k < i ? 'is-done' : k === i ? 'is-now' : ''; });
  }
  function error(code) {
    if (INTERNO && ERR_INTERNO[code]) { INTERNO.pide(code === 'auth' ? 'basic' : code); out.innerHTML = '<div class="lgue__card lgue__msg lgue__msg--err" role="alert">' + esc(ERR_INTERNO[code]) + '</div>'; return; }
    var k = ['url', 'unreachable', 'blocked', 'password', 'rate', 'timeout'].indexOf(code) >= 0 ? code : 'generic';
    out.innerHTML = '<div class="lgue__card lgue__msg lgue__msg--err" role="alert">' + esc(t('errors.' + k)) + '</div>';
  }

  /* ---------- Resultado ---------- */
  function pintar(r) {
    var ai = r.ai || {};
    var lvl = nivel(r.score);
    var fallos = (r.items || []).filter(function (i) { return i.status === 'fail'; }).length;
    var h = '';
    h += '<section class="lgue__card lgue__top lgue--' + lvl + '"><div class="lgue__ring" style="--p:0" data-score="' + r.score + '"><svg viewBox="0 0 120 120" aria-hidden="true"><circle cx="60" cy="60" r="52"/><circle class="lgue__ring-v" cx="60" cy="60" r="52"/></svg>' +
      '<div><b data-count>0</b><small>/100</small></div></div><div class="lgue__top-txt"><p class="lgue__kicker">' + esc(t('score')) + '</p>' +
      '<h2>' + esc(r.host) + ' <span class="lgue__plat">' + esc(t('platforms.' + (r.platform || 'otra'))) + '</span></h2>' +
      '<p class="lgue__level">' + esc(t('level_' + lvl)) + (fallos ? ' ' + esc(t('fails', { n: fallos })) : '') + '</p>' +
      (ai.summary ? '<p class="lgue__summary">' + esc(ai.summary) + '</p>' : '') +
      '<div class="lgue__acts"><a class="lgue__btn" href="#lgue-lead">' + esc(t('lead.send')) + '</a><button type="button" class="lgue__btn" data-share>' + esc(t('pdf')) + '</button></div>' +
      '<div class="lgue__groups-mini">' + GRUPOS.map(function (g) {
        var n = r.groups[g];
        return '<div><span>' + esc(t('groups.' + g + '.t')) + '</span><i class="lgue__bar lgue--' + nivel(n) + '"><i style="width:' + (n || 0) + '%"></i></i><b>' + (n == null ? '–' : n) + '</b></div>';
      }).join('') + '</div></div></section>';
    h += '<p class="lgue__legal" role="note">' + esc(t('not_advice')) + '</p>';
    h += fechas();
    h += vista(r);
    h += '<div class="lgue__grid2">' + GRUPOS.map(function (g) { return grupo(r, g); }).join('') + '</div>';
    h += cta(r);
    h += '<p class="lgue__disc">' + esc(t('disclaimer')) + (r.cached ? ' ' + esc(t('cached')) : '') + '</p>';
    h += '<p class="lgue__again"><button type="button" class="lgue__btn lgue__btn--ghost" data-again>' + esc(t('again')) + '</button></p>';
    out.innerHTML = h;
    animar(r);
    enlazar(r);
  }

  // Fechas clave: lo que ya es obligatorio (todas en vigor) para que se entienda por qué se mira cada cosa.
  function fechas() {
    var F = [['omnibus', '2022-05-28'], ['gpsr', '2024-12-13'], ['eaa', '2025-06-28'], ['button', '2026-06-19'], ['guarantee', '2026-09-27']];
    var hoy = new Date().toISOString().slice(0, 10);
    var fmt = function (d) { try { return new Date(d + 'T12:00:00Z').toLocaleDateString(LOC, { day: 'numeric', month: 'short', year: 'numeric' }); } catch (e) { return d; } };
    return '<section class="lgue__card lgue__dates"><h2 class="lgue__h2">' + esc(t('dates.title')) + '</h2><p class="lgue__sub">' + esc(t('dates.lead')) + '</p><ol class="lgue__timeline">' +
      F.map(function (f) {
        var vigor = f[1] <= hoy;
        return '<li class="' + (vigor ? 'is-on' : '') + '"><span class="lgue__tl-dot" aria-hidden="true"></span><time datetime="' + f[1] + '">' + esc(fmt(f[1])) + '</time>' +
          '<b>' + esc(t('dates.items.' + f[0] + '.t')) + '</b><small>' + esc(t('dates.items.' + f[0] + '.d')) + '</small>' +
          '<em>' + esc(vigor ? t('dates.in_force') : t('dates.soon')) + '</em></li>';
      }).join('') + '</ol></section>';
  }

  // Lo que ve un visitante nuevo: la portada con el banner de cookies marcado.
  function vista(r) {
    var v = r.view, it = function (id) { return (r.items || []).filter(function (x) { return x.id === id; })[0]; };
    var bn = it('cookie_banner');
    var h = '<section class="lgue__card lgue__view"><h2 class="lgue__h2">' + esc(t('view.title')) + '</h2><p class="lgue__sub">' + esc(t('view.lead')) + '</p>';
    if (r.nav_error || !v || !v.shot) return h + '<p class="lgue__msg">' + esc(t('view.fallback')) + '</p></section>';
    var W = v.ancho || 1280, H = v.alto || 800;
    var cajas = (v.cajas || []).map(function (c) {
      return '<div class="lgue__box ' + (c.ok ? 'is-ok' : 'is-bad') + ' lgue__box--' + c.k + (c.x + c.w / 2 > W * 0.6 ? ' is-right' : '') + (c.y < 30 ? ' is-top' : '') + '" style="left:' + (c.x / W * 100) + '%;top:' + (c.y / H * 100) + '%;width:' + (c.w / W * 100) + '%;height:' + (c.h / H * 100) + '%">' +
        '<span>' + (c.ok ? '✓ ' : '✕ ') + esc(t('box.' + c.k)) + '</span></div>';
    }).join('');
    h += '<div class="lgue__view-grid"><figure class="lgue__shot" style="aspect-ratio:' + W + '/' + H + '"><img src="' + esc(API + v.shot) + '" alt="' + esc(t('view.alt', { host: r.host })) + '" loading="lazy" width="' + W + '" height="' + H + '">' + cajas + '</figure>';
    h += '<div class="lgue__reads"><h3>' + esc(t('view.banner')) + '</h3><p class="lgue__fine">' + esc(bn ? t('items.cookie_banner.' + (bn.status === 'ok' ? (bn.ev && bn.ev.code ? 'ok_code' : 'ok') : bn.status === 'na' ? 'fix_na' : 'fix_short'), { cmp: (bn.ev && bn.ev.cmp) || '' }) : '') + '</p>';
    return h + '</div></div></section>';
  }

  function chip(ok, txt) { return '<span class="' + (ok ? 'is-ok' : 'is-bad') + '">' + (ok ? '✓ ' : '✕ ') + esc(txt) + '</span>'; }
  function item(i, r) {
    var ev = i.ev || {}, st = i.status, plat = r.platform || 'otra';
    var vars = { n: ev.n || '', host: ev.external || '', cmp: ev.cmp || '', announced: ev.announced || '', law: ev.law || '', terms: (Array.isArray(ev.found) ? ev.found : []).map(function (f) { return '«' + f.term + '»'; }).join(', ') };
    var malo = st === 'fail' || st === 'warn' || (st === 'info' && (i.id === 'vat_b2b' || i.id === 'oss'));
    var fix = '';
    if (st === 'warn' || st === 'fail' || st === 'probable' || ((st === 'info' || st === 'na') && INFO_TXT[i.id])) {
      var k = ev.variant && t('items.' + i.id + '.fix_' + ev.variant) ? 'fix_' + ev.variant : ev.digital ? (ev.exclusion ? 'digital_ok' : 'digital') : ev.external ? 'fix_external' : ev.announced ? 'fix_announced' : st === 'info' ? 'fix_info' : st === 'na' ? 'fix_na' : st === 'warn' && t('items.' + i.id + '.fix_warn') ? 'fix_warn' : 'fix';
      fix = t('items.' + i.id + '.' + k, vars);
      // El arreglo según la plataforma va detrás del general.
      // Si el texto habla de nuestra app o módulo y no está publicado en la web, no se dice.
      var pk0 = ARREGLA[plat] && ARREGLA[plat][i.id];
      var fp = malo && !ev.external && !ev.digital && (!pk0 || PROD(pk0)) ? t('items.' + i.id + '.fix_' + plat) : '';
      if (fp) fix += (fix ? ' ' : '') + fp;
    }
    if (st === 'ok' && t('items.' + i.id + '.ok')) fix = t('items.' + i.id + (ev.digital ? '.digital_ok' : ev.external ? '.ok_external' : ev.code ? '.ok_code' : '.ok'), vars);
    // Descargas y servicios a la vez (lineagrafica.es): las descargas pueden quedar fuera, el hosting y las suscripciones no.
    if (ev.mixed) fix += (fix ? ' ' : '') + t('items.' + i.id + '.mixed');
    var chips = '';
    if (i.id === 'legal_notice') chips = ['company', 'taxId', 'address', 'email', 'register'].map(function (c) { return chip(ev[c], t('ev.' + c)); }).join('');
    if (i.id === 'withdrawal_info' && ev.url) chips = [['plazo14', 'days14'], ['form', 'form'], ['cost', 'cost'], ['how', 'how']].map(function (c) { return chip(ev[c[0]], t('ev.' + c[1])); }).join('');
    if (i.id === 'shipping' && ev.url) chips = chip(ev.plazo, t('ev.deadline')) + chip(ev.coste, t('ev.cost'));
    if (i.id === 'privacy_policy' && ev.url) chips = chip(ev.controller, t('ev.controller')) + chip(ev.rights, t('ev.rights')) + (ev.obsolete ? '<span class="is-bad" title="' + esc(dec(ev.text || '')) + '">✕ ' + esc(t('ev.obsolete', { law: ev.obsolete })) + '</span>' : '');
    if (i.id === 'gpsr' && ev.url) chips = chip(ev.manufacturer, t('ev.manufacturer')) + chip(ev.safety, t('ev.safety')) + chip(ev.contact, t('ev.contact'));
    if (i.id === 'a11y_basics' && st !== 'na') chips = chip(!ev.lang, t('ev.lang')) + chip(!ev.alt, t('ev.alt', { n: ev.alt })) + chip(!ev.names, t('ev.names', { n: ev.names })) + chip(!ev.labels, t('ev.labels', { n: ev.labels })) + chip(!ev.zoom, t('ev.zoom'));
    if (i.id === 'green' && ev.found) chips = ev.found.map(function (f) { return '<span class="is-bad" title="' + esc(dec(f.text)) + '">' + esc(f.term) + '</span>'; }).join('');
    var link = ev.url ? ' <a class="lgue__link" href="' + esc(ev.url) + '" target="_blank" rel="noopener nofollow">' + esc(t('ev.see')) + ' ↗</a>' : '';
    var extra = '';
    var pk = ARREGLA[plat] && ARREGLA[plat][i.id], pu = pk && PROD(pk);
    // Shopify sin botón: directo a la ficha de la App Store en su idioma, con UTM para medirlo en Partners y GA4 (orden 1533, 22/10/2026).
    var tienda = plat === 'shopify' && i.id === 'withdrawal_button';
    if (tienda) pu = 'https://apps.shopify.com/lg-withdrawal?' + (TIENDA_LOC[LOC] || TIENDA_LOC[LANG] ? 'locale=' + (TIENDA_LOC[LOC] || TIENDA_LOC[LANG]) + '&' : '') +
      'utm_source=lineagrafica&utm_medium=comprobador-ue&utm_campaign=desistimiento&utm_content=' + encodeURIComponent(st + '-' + LOC);
    if (malo && pu && !ev.external && !ev.digital) extra += '<a class="lgue__mod" href="' + esc(pu) + '"' + (tienda ? ' data-lgue-app="withdrawal" target="_blank" rel="noopener"' : '') + '>' + esc(t(plat === 'shopify' ? 'fixes.app' : 'fixes.module', { name: t('names.' + pk) })) + ' →</a>';
    var gu = GUIA[i.id] && PROD(GUIA[i.id]);
    if (malo && gu) extra += '<a class="lgue__mod lgue__mod--guide" href="' + esc(gu) + '">' + esc(t('fixes.guide')) + ' →</a>';
    // Cookies: solo se mira el banner; el bloqueo previo se revisa a mano (Jose, 16/10/2026), con el formulario de contacto.
    if (i.id === 'cookie_banner' && st !== 'na') {
      fix += (fix ? ' ' : '') + t('items.cookie_banner.review');
      extra += '<a class="lgue__mod" href="#lgue-lead">' + esc(t('items.cookie_banner.review_cta')) + ' →</a>';
    }
    var ley = t('items.' + i.id + '.law');
    return '<li class="lgue__item is-' + st + '"><span class="lgue__ico">' + ico(st) + '</span><div><p class="lgue__item-t">' + esc(t('items.' + i.id + '.t')) +
      ' <span class="lgue__st">' + esc(t('status.' + st)) + '</span>' + link + '</p>' + (ley ? '<p class="lgue__law">' + esc(ley) + '</p>' : '') +
      (chips ? '<p class="lgue__chips">' + chips + '</p>' : '') + (fix ? '<p class="lgue__fix">' + esc(fix) + '</p>' : '') + (extra ? '<p class="lgue__fixes">' + extra + '</p>' : '') + '</div></li>';
  }
  function grupo(r, g) {
    var n = r.groups[g];
    var lis = (r.items || []).filter(function (i) { return i.group === g; })
      .sort(function (a, b) { return ORDEN[a.status] - ORDEN[b.status]; })
      .map(function (i) { return item(i, r); }).join('');
    return '<section class="lgue__card lgue__group"><header><h2 class="lgue__h3">' + esc(t('groups.' + g + '.t')) + '</h2><b class="lgue__pill lgue--' + nivel(n) + '">' + (n == null ? '–' : n) + '</b></header>' +
      '<p class="lgue__fine">' + esc(t('groups.' + g + '.d')) + '</p><ul class="lgue__items">' + lis + '</ul></section>';
  }
  function cta(r) {
    var priv = '<a href="' + esc(PRIVACY) + '" target="_blank" rel="noopener">' + esc(t('lead.privacy')) + '</a>';
    var h = '<section class="lgue__card lgue__cta-main lgue__lead-box" id="lgue-lead"><h2 class="lgue__h2">' + esc(t('cta.title')) + '</h2><p class="lgue__cta-text">' + esc(t('cta.text')) + '</p>' +
      '<form class="lgue__lead lgue__lead-panel" novalidate><div class="lgue__row"><label>' + esc(t('lead.name')) + '<input name="name" type="text" autocomplete="name" maxlength="120"></label>' +
      '<label>' + esc(t('lead.email')) + ' *<input name="email" type="email" autocomplete="email" maxlength="120" required aria-describedby="lgue-lead-msg"></label>' +
      '<label>' + esc(t('lead.phone')) + ' *<input name="phone" type="tel" autocomplete="tel" maxlength="40" required aria-describedby="lgue-lead-msg"></label></div>' +
      '<label>' + esc(t('lead.message')) + '<textarea name="message" rows="3" maxlength="1000"></textarea></label>' +
      '<label class="lgue__hp" aria-hidden="true">Website<input name="website" type="text" tabindex="-1" autocomplete="off"></label>' +
      '<label class="lgue__check"><input name="consent" type="checkbox" aria-describedby="lgue-lead-msg"> <span>' + esc(t('lead.consent')).replace('{privacy}', priv) + '</span></label>' +
      '<p class="lgue__lead-msg" id="lgue-lead-msg" role="alert"></p>' +
      '<div class="lgue__lead-send"><button class="lgue__btn" type="submit">' + esc(t('lead.send')) + '</button><p class="lgue__trust">' + esc(t('lead.trust')) + '</p></div></form></section>';
    var pack = r.platform === 'prestashop' && PROD('ps-pack');
    if (pack) h += '<section class="lgue__card lgue__cta-ps"><h3 class="lgue__h3">' + esc(t('cta.ps_title')) + '</h3><p>' + esc(t('cta.ps_text')) + '</p>' +
      '<a class="lgue__btn lgue__btn--ghost" href="' + esc(pack) + '">' + esc(t('cta.ps_button')) + '</a></section>';
    if (IA_URL) h += '<section class="lgue__card lgue__cta-ia"><h3 class="lgue__h3">' + esc(t('cta.ia_title')) + '</h3><p>' + esc(t('cta.ia_text')) + '</p>' +
      '<a class="lgue__btn lgue__btn--ghost" href="' + esc(IA_URL) + (r.host ? '?url=' + encodeURIComponent(r.host) : '') + '">' + esc(t('cta.ia_button')) + '</a></section>';
    return h;
  }

  /* ---------- Animación de la nota ---------- */
  function animar(r) {
    var ring = out.querySelector('.lgue__ring'), num = ring.querySelector('[data-count]');
    var fin = r.score || 0, t0 = null, dur = REDUCED ? 1 : 1100;
    (function f(ts) {
      if (!t0) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur), e = 1 - Math.pow(1 - p, 3), v = Math.round(fin * e);
      num.textContent = v; ring.style.setProperty('--p', v);
      if (p < 1) requestAnimationFrame(f);
    })(performance.now());
  }

  /* ---------- Compartir: el informe por email ---------- */
  // Para compartir el resultado hay que dar el email: se le manda el enlace por correo y después sale aquí para copiarlo.
  function pedirInforme(r, origen) {
    var previo = document.activeElement, guardado = '';
    try { guardado = localStorage.getItem('lg_tool_email') || ''; } catch (e) {}
    var priv = '<a href="' + esc(PRIVACY) + '" target="_blank" rel="noopener">' + esc(t('lead.privacy')) + '</a>';
    var m = document.createElement('div');
    m.className = 'lgue lgue__modal';
    m.innerHTML = '<div class="lgue__modal-box lgue__mail" role="dialog" aria-modal="true" aria-labelledby="lgue-mail-t" aria-describedby="lgue-mail-d" tabindex="-1">' +
      '<button type="button" class="lgue__modal-x" data-cancel aria-label="' + esc(t('mail.close')) + '">×</button>' +
      '<h2 class="lgue__h2" id="lgue-mail-t">' + esc(t('mail.title')) + '</h2><p class="lgue__sub" id="lgue-mail-d">' + esc(t('mail.text', { host: r.host })) + '</p>' +
      '<form class="lgue__lead lgue__mail-form" novalidate><label>' + esc(t('lead.email')) + ' *<input name="email" type="email" autocomplete="email" maxlength="120" required aria-describedby="lgue-mail-msg" value="' + esc(guardado) + '"></label>' +
      '<label class="lgue__hp" aria-hidden="true">Website<input name="website" type="text" tabindex="-1" autocomplete="off"></label>' +
      '<label class="lgue__check"><input name="privacy" type="checkbox" required aria-describedby="lgue-mail-msg"> <span>' + esc(t('lead.consent')).replace('{privacy}', priv) + ' *</span></label>' +
      '<label class="lgue__check"><input name="marketing" type="checkbox"> <span>' + esc(t('mail.marketing')) + '</span></label>' +
      '<p class="lgue__lead-msg" id="lgue-mail-msg" role="alert"></p>' +
      '<button class="lgue__btn" type="submit">' + esc(t('mail.send')) + '</button></form></div>';
    document.body.appendChild(m);
    var box = m.querySelector('.lgue__modal-box'), lf = box.querySelector('form');
    var cerrar = function () { document.removeEventListener('keydown', tecla); m.remove(); if (previo && previo.focus) previo.focus(); };
    var tecla = function (ev) {
      if (ev.key === 'Escape') cerrar();
      if (ev.key === 'Tab') { // foco dentro del modal
        var f = [].slice.call(box.querySelectorAll('button, input:not([tabindex="-1"]), a[href]'));
        if (!f.length) return;
        if (ev.shiftKey && document.activeElement === f[0]) { ev.preventDefault(); f[f.length - 1].focus(); }
        else if (!ev.shiftKey && document.activeElement === f[f.length - 1]) { ev.preventDefault(); f[0].focus(); }
      }
    };
    document.addEventListener('keydown', tecla);
    m.addEventListener('click', function (ev) { if (ev.target === m) cerrar(); });
    m.querySelector('[data-cancel]').addEventListener('click', cerrar);
    lf.elements.email.focus();
    lf.addEventListener('change', function (ev) { var g = lf.querySelector('.lgue__lead-msg'); if (ev.target.checked || ev.target.name === 'email') { g.textContent = ''; g.className = 'lgue__lead-msg'; ev.target.removeAttribute('aria-invalid'); } });
    ga('ue_check_share_open', { score: r.score, from: origen });
    lf.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var f = lf.elements, msg = lf.querySelector('.lgue__lead-msg'), b = lf.querySelector('button[type=submit]');
      var mal = function (texto, campo) {
        msg.className = 'lgue__lead-msg is-bad'; msg.textContent = texto;
        [f.email, f.privacy].forEach(function (c) { c.removeAttribute('aria-invalid'); });
        if (campo) { campo.setAttribute('aria-invalid', 'true'); campo.focus(); }
      };
      var email = f.email.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) return mal(t('lead.err_email'), f.email);
      if (!f.privacy.checked) return mal(t('lead.err_consent'), f.privacy);
      mal('', null); msg.className = 'lgue__lead-msg';
      var qs = new URLSearchParams(location.search);
      var body = { id: r.id, lang: LANG, email: email, privacy: true, marketing: f.marketing.checked, website: f.website.value,
        utm_source: qs.get('utm_source') || '', utm_medium: qs.get('utm_medium') || '', utm_campaign: qs.get('utm_campaign') || '', gclid: qs.get('gclid') || '',
        referrer: document.referrer || '', landing: location.href.split('#')[0] };
      b.disabled = true; b.setAttribute('aria-busy', 'true');
      api('/api/normativa/informe', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(body) }).then(function (res) {
        b.disabled = false; b.removeAttribute('aria-busy');
        if (res && res.ok) {
          try { localStorage.setItem('lg_tool_email', email); } catch (e) {}
          ga('ue_check_share', { score: r.score, platform: r.platform, marketing: f.marketing.checked ? 1 : 0 });
          return hecho(res.mail !== false, email, res.pdf);
        }
        if (res && res.error === 'email') mal(t('lead.err_email'), f.email);
        else if (res && res.error === 'privacy') mal(t('lead.err_consent'), f.privacy);
        else if (res && res.error === 'rate') mal(t('mail.err_rate'), null);
        else mal(t('lead.err_generic'), null);
      });
    });
    // Enviado: el enlace para copiar (el de compartir, con la tarjeta de la nota) y, si el móvil sabe, compartir.
    function hecho(mandado, email, pdf) {
      var url = API + '/ue/r/' + r.id + '?lang=' + LANG;
      box.innerHTML = '<button type="button" class="lgue__modal-x" data-cancel aria-label="' + esc(t('mail.close')) + '">×</button>' +
        '<h2 class="lgue__h2" id="lgue-mail-t">' + esc(t(mandado ? 'mail.ok_title' : 'mail.nomail_title')) + '</h2>' +
        '<p class="lgue__sub" id="lgue-mail-d" role="status">' + esc(t(mandado ? 'mail.ok' : 'mail.nomail', { email: email })) + '</p>' +
        '<div class="lgue__copy"><label class="lgue__sr" for="lgue-mail-url">' + esc(t('mail.link')) + '</label><input id="lgue-mail-url" type="text" readonly value="' + esc(url) + '">' +
        '<button type="button" class="lgue__btn" data-copy>' + esc(t('mail.copy')) + '</button></div>' +
        (pdf ? '<a class="lgue__btn" href="' + esc(pdf) + '" target="_blank" rel="noopener" download>' + esc(t('mail.download')) + '</a> ' : '') +
        (navigator.share ? '<button type="button" class="lgue__btn lgue__btn--ghost" data-native>' + esc(t('share')) + '</button>' : '');
      box.querySelector('[data-cancel]').addEventListener('click', cerrar);
      var inp = box.querySelector('input'), cp = box.querySelector('[data-copy]');
      inp.addEventListener('focus', function () { inp.select(); });
      cp.addEventListener('click', function () {
        var ok = function () { cp.textContent = t('copied'); setTimeout(function () { cp.textContent = t('mail.copy'); }, 1600); };
        inp.select();
        if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(url).then(ok, function () { try { document.execCommand('copy'); ok(); } catch (e) {} });
        else { try { document.execCommand('copy'); ok(); } catch (e) {} }
      });
      var nt = box.querySelector('[data-native]');
      if (nt) nt.addEventListener('click', function () { navigator.share({ title: t('title'), text: r.host + ' · ' + r.score + '/100', url: url }).catch(function () {}); });
      cp.focus();
    }
  }

  /* ---------- Eventos del resultado ---------- */
  function enlazar(r) {
    var sh = out.querySelector('[data-share]');
    if (sh) sh.addEventListener('click', function () { pedirInforme(r, 'top'); });
    var ag = out.querySelector('[data-again]');
    if (ag) ag.addEventListener('click', function () { input.value = ''; try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {} out.innerHTML = ''; root.scrollIntoView({ behavior: 'smooth' }); input.focus(); });
    var lf = out.querySelector('.lgue__lead');
    if (lf) lf.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var f = lf.elements, msg = lf.querySelector('.lgue__lead-msg'), b = lf.querySelector('button');
      var mal = function (texto, campo) {
        msg.className = 'lgue__lead-msg is-bad'; msg.textContent = texto;
        [f.email, f.phone, f.consent].forEach(function (c) { c.removeAttribute('aria-invalid'); });
        if (campo) { campo.setAttribute('aria-invalid', 'true'); campo.focus(); }
      };
      var email = f.email.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) return mal(t('lead.err_email'), f.email);
      if (!/^(?=(?:\D*\d){6,20}\D*$)[+\d\s().-]{6,40}$/.test(f.phone.value.trim())) return mal(t('lead.err_phone'), f.phone);
      if (!f.consent.checked) return mal(t('lead.err_consent'), f.consent);
      mal('', null); msg.className = 'lgue__lead-msg';
      var qs = new URLSearchParams(location.search);
      var body = { id: r.id, lang: LANG, name: f.name.value.trim(), email: email, phone: f.phone.value.trim(), message: f.message.value.trim(), website: f.website.value, consent: true,
        utm_source: qs.get('utm_source') || '', utm_medium: qs.get('utm_medium') || '', utm_campaign: qs.get('utm_campaign') || '', gclid: qs.get('gclid') || '',
        referrer: document.referrer || '', landing: location.href.split('#')[0] };
      b.disabled = true; b.setAttribute('aria-busy', 'true');
      api('/api/normativa/lead', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(body) }).then(function (res) {
        b.disabled = false; b.removeAttribute('aria-busy');
        if (res && res.ok) {
          ga('ue_check_lead', { score: r.score, platform: r.platform });
          lf.innerHTML = '<p class="lgue__msg lgue__msg--ok lgue__lead-ok" role="status" tabindex="-1">' + esc(t('lead.ok')) + '</p>';
          lf.firstChild.focus({ preventScroll: true });
        } else if (res && res.error === 'email') mal(t('lead.err_email'), f.email);
        else if (res && res.error === 'phone') mal(t('lead.err_phone'), f.phone);
        else if (res && res.error === 'consent') mal(t('lead.err_consent'), f.consent);
        else mal(t('lead.err_generic'), null);
      });
    });
  }

  // Enlace compartido: #r=<id>
  var m = /[#&]r=([A-Za-z0-9_-]{6,20})/.exec(location.hash);
  if (m) { btn.disabled = true; cargando('ai'); seguir(m[1]); }
})();
